import type * as React from 'react';
import { useIntl } from 'react-intl';

import type { Config } from '@xingternal/meta-renderer';

import { LegalFooterStandaloneInner } from './legal-footer-standalone-inner';
import { legalFooter } from './loggedout-config/legal-footer';
import type { Language } from './types';

export const LegalFooterStandaloneLoggedout: React.FC = () => {
  const translate = (id: string): string => {
    return intl.formatMessage({ id });
  };
  const intl = useIntl();
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const lang = intl.locale as Language;

  const config: Config = legalFooter(translate, lang);

  return <LegalFooterStandaloneInner config={config} />;
};
